/**
 * Stable CSS class names for E2E — Create Return page.
 */
export const CR = {
    page: 'create-return-page',
    layout: 'create-return-page__layout',

    headerRow: 'create-return-page__header-row',
    orderNumberText: 'create-return-page__order-number',
    breadcrumbSection: 'create-return-page__breadcrumb-section',

    shippingInfoRow: 'create-return-page__shipping-info-row',
    orderDateRow: 'create-return-page__order-date-row',
    stepperSection: 'create-return-page__stepper-section',

    shippingFilterRow: 'create-return-page__shipping-filter-row',
    shippingFilterPaper: 'create-return-page__shipping-filter-paper',
    shippingFilterInput: 'create-return-page-input__shipping-filter-input',
    shippingFilterIconButton: 'create-return-page-input__shipping-filter-icon-button',

    step1Section: 'create-return-page__step1-section',
    step2Section: 'create-return-page__step2-section',
    step3Section: 'create-return-page__step3-section',

    footerActionsRow: 'create-return-page__footer-actions-row',
    noSelectionText: 'create-return-page__no-selection-text',
    continueButton: 'create-return-page-input--button-continue',

    emptyGoBackRow: 'create-return-page__empty-go-back-row',
    goBackLink: 'create-return-page-input--link-go-back',
    loadingSection: 'create-return-page__loading-section',
} as const;

export const crCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

